
import uploadService from "../../GeneralServices/Upload"
export default {
    /*uploadFile: async function (file, queryString) {
        try {
            let formData = new FormData();
            formData.append("file", file);
            const { data } = await uploadService.services.uploadFile(formData, queryString, "public_FW25b8h4qXR3VoqLnET1Y8B4gp3T");
            if (data.files) {
                let [responseFile] = data.files;
                return responseFile.fileUrl
            } else {
                return null
            }
        } catch (error) {
            return null
        }
    },*/
    uploadFile: async function (file, queryString, token = "") {
        try {
            let formData = new FormData();
            formData.append("file", file);
            const { data } = await uploadService.services.uploadFile(formData, queryString, token);
            if (data.status) {
                return data.url
            } else {
                return null
            }
        } catch (error) {
            return null
        }
    },
    getFileData: function (folderPath, fileFormat) {
        let fileName = `file-${Date.now() + '-' + Math.round(Math.random() * 1E9)}${fileFormat}`
        return {
            fileName: fileName,
            fileNameFallback: fileName,
            fileNameVariablesEnabled: true,
            filePath: `${folderPath}/${fileName}`,
            folderPath: folderPath,
            folderPathVariablesEnabled: true,
        };
    },
    buildQueryString: function (query) {
        return new URLSearchParams(query).toString();
    }
}